export const devDomain: string[] = [
  'jdillinger.dev.local:4200',
  'man.dev.local:4200',
  'alinater.dev.local:4200',
  'front1.dev.local:4200',
  'star.dev.local:4200',
  'frontnumberfour.dev.local:4200',
  'azino777.dev.local:4200',
];
